/* 'cours'-mode sections pane (chat.tsx). Thin wrapper around the unified */
/* ContentSectionsEditor so the chat flow and the content editor share the same */
/* RichDoc format (spec 02 — NS-content-richdoc-legacy). */

import ContentSectionsEditor from './content-sections-editor';
import type { SectionUpdatedEvent, SectionCreatedEvent, SectionsReorderedEvent } from '../lib/chat-api';

export interface CourseSectionsPanelProps {
  documentId: string;
  incomingSection?: SectionUpdatedEvent | null;
  incomingCreated?: SectionCreatedEvent | null;
  incomingReordered?: SectionsReorderedEvent | null;
  onClose?: () => void;
}

export default function CourseSectionsPanel({
  documentId,
  incomingSection,
  incomingCreated,
  incomingReordered,
  onClose,
}: CourseSectionsPanelProps) {
  return (
    <div className="flex flex-col h-full overflow-hidden bg-background">
      <div className="flex items-center gap-2 px-4 py-[10px] border-b border-border flex-none">
        <span className="flex-1 font-extrabold text-[14px] text-foreground">Sections du document</span>
        {onClose && (
          <button type="button" onClick={onClose} className="bg-transparent border-none text-muted-foreground font-bold text-[18px] cursor-pointer leading-none px-[6px] py-0.5" aria-label="Fermer le panneau">✕</button>
        )}
      </div>
      <div className="flex-1 overflow-y-auto p-[12px_16px]">
        <ContentSectionsEditor
          documentId={documentId}
          editable
          incomingSection={incomingSection}
          incomingCreated={incomingCreated}
          incomingReordered={incomingReordered}
        />
      </div>
    </div>
  );
}
